/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '../request';
/**
 * @description 出厂图纸和出厂报告
 */

export function getExitDrawing(data) {
  return request.get("/hd/hdprojectproduct/getExitDrawing", {
    params: data
  });
}
/**
 * @description get bom
 */

export function getHdProjectBom(data) {
  return request.get("/hd/hdprojectproduct/getBom", {
    params: data
  });
}
/**
 * @description get info
 */

export function getHdProjectProductInfo(data) {
  return request.get("/hd/hdprojectproduct/getNameplate", {
    params: data
  });
}